<script setup lang="ts">
import { Input } from '@/components/ui/input';
import { cn } from '@/lib/utils';

import type { HTMLAttributes } from 'vue';

export type InputType = 'text' | 'email' | 'password' | 'number' | 'tel' | 'url';

interface Props {
  type?: InputType;
  placeholder?: string;
  disabled?: boolean;
  readonly?: boolean;
  error?: string;
  id?: string;
  maxlength?: number;
  class?: HTMLAttributes['class'];
}

const props = withDefaults(defineProps<Props>(), {
  type: 'text',
  placeholder: '',
  disabled: false,
  readonly: false,
  error: '',
  id: '',
  maxlength: undefined,
  class: undefined,
});

const model = defineModel<string>({ default: '' });
</script>

<template>
  <div class="w-full">
    <Input
      :id="id"
      v-model="model"
      :type="type"
      :placeholder="placeholder"
      :disabled="disabled"
      :readonly="readonly"
      :maxlength="maxlength"
      :aria-invalid="!!error || undefined"
      :class="cn(props.class)"
    />
    <p v-if="error" class="text-destructive mt-1 text-sm">
      {{ error }}
    </p>
  </div>
</template>
